<template>
  <base-slide-over ref="approveWithChangesSlideover" title="Approval Changes" size="5xl" style="z-index: 10000">
    <base-content>
      <component :is="currentComponent" :business-id="businessId" :user-id="userId"></component>
      <inline-error id="approve-changes-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-content>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-end">
        <base-button type="flat" class="tw-w-auto tw-mr-2" @click="hide()">
          Cancel
        </base-button>
        <base-button class="tw-w-auto" @click="approveRxAuth" :loading="isSaving">
          Approve Changes
        </base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import InlineError from "@/components/InlineError";
import { mapGetters } from "vuex";

export default {
  components: {
    InlineError,
    BusinessMemberPrescriptions: () => import("@/views/business/member/prescriptions/BusinessMemberPrescriptions.vue"),
  },
  name: "ApproveRxAuthWithChanges",
  props: {
    businessId: String,
  },
  data() {
    return {
      isSaving: false,
      todoItemId: null,
      userId: null,
      prescriptions: [],
      errorTitle: "",
      errorMessage: "",
      error: null,
      currentComponent: null,
    };
  },
  computed: {
    ...mapGetters("location", ["location", "locations"]),
  },
  methods: {
    show(todoItemId, userId) {
      this.todoItemId = todoItemId;
      this.userId = userId;
      this.$refs.approveWithChangesSlideover.show();
      this.currentComponent = "BusinessMemberPrescriptions";
    },
    hide() {
      this.reset();
      this.$refs.approveWithChangesSlideover.hide();
    },
    reset() {
      this.todoItemId = null;
      this.userId = null;
    },
    approveRxAuth() {
      this.isSaving = true;

      this.$axios
        .post(`/businesses/${this.businessId}/todo/${this.todoItemId}/approve?isWithChanges=true`)
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Authorization Approved",
            message: `Your approval was submitted. Thank you.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error submitting approval`;
          this.errorMessage = "Sorry, we had trouble submitting this approval. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
